import { FunctionComponent } from 'react';
import {
  DynamicContentName,
  DynamicContentsItems,
} from '../../../app-kit/components/DynamicContent/types';
import { SuburbPageFlatmatesBrick } from './SuburbPageFlatmatesBrick';

export const SuburbPageFlatmatesBrickWithData: FunctionComponent = () => {
  const mockData = {
    title: 'Rental room insights',
    subtitle: 'Uncover what your spare room may be worth',
    averageRoomRent: {
      title: 'Average room rent',
      value: '$342',
      unit: 'per week',
      description: [{ text: 'Equivalent annual income ' }, { text: '$17,784', bold: true }],
    },
    supplyAndDemand: {
      title: 'Supply and demand',
      value: '42:1',
      description: [{ text: 'People looking per room listed' }],
    },
    footerNote: [
      {
        __typename: 'Text',
        name: DynamicContentName.Text,
        text: 'Visit flatmates.com.au to ',
        color: 'linkSecondary',
      },
      {
        __typename: 'WebLink',
        name: DynamicContentName.WebLink,
        title: 'view all rooms for rent in Glenroy',
        url: 'https://flatmates.com.au',
        isExternal: true,
        variant: 'primary',
      },
    ] as DynamicContentsItems,
  };

  return (
    <SuburbPageFlatmatesBrick
      title={mockData.title}
      subtitle={mockData.subtitle}
      averageRoomRentSubBrick={mockData.averageRoomRent}
      supplyAndDemandSubBrick={mockData.supplyAndDemand}
      footerNote={mockData.footerNote}
    />
  );
};
